import React, { Component } from 'react';
import Input from '../../components/UI/Input/Input';
import Card from '@material-ui/core/Card';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Aux from '../../hoc/Aux';
import axios from '../../axios-ns';
import VpnKeyIcon from "@material-ui/icons/VpnKeyOutlined";
import * as messages from '../../messages';
import { Link } from 'react-router-dom'

class ResetPassword extends Component {
    state = {
        isSent: false,
        loading: false,
        invalidCode: false,
        controls: {
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: messages.YOUR_NEW_PASSWORD
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                touched: false
            },
            repeatPassword: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Powtórz hasło'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6,
                    sameAs: 'password'
                },
                touched: false
            }
        }
    };

    componentDidMount() {
        this.setState({ ...this.state, loading: true });
        axios.get('check/' + this.props.match.params.changePasswordCode)
            .then(response => {
                this.setState({ ...this.state, loading: false});
            })
            .catch(err => {
                this.setState({ ...this.state, error: messages[err.response.data.message], loading: false, invalidCode: true });
            })
    }

    checkValidity(value, rules) {
        let isValid = true;

        if (!rules) {
            return true;
        }

        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }

        return isValid;
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: this.checkValidity(event.target.value, this.state.controls[controlName.validation]),
                touched: true
            }
        };
        this.setState({ controls: updatedControls });
    }

    submitHandler = (event) => {
        event.preventDefault();
        this.resetPassword(this.state.controls.password.value, this.props.match.params.changePasswordCode);
    }

    resetPassword = (password, resetCode) => {
        this.setState({ ...this.state, laoding: true });
        const resetData = {
            password: password,
            resetCode: resetCode
        }

        let url = 'reset-password';

        axios.post(url, resetData)
            .then(response => {
                this.setState({ ...this.state, isSent: true, loading: false });
            })
            .catch(err => {
                this.setState({ ...this.state, isSent: false, error: messages[err.response.data.message], loading: false });
            });
    }

    render() {
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }

        let form = formElementsArray.map(
            formElement => (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    value={formElement.config.value} />
            )
        );

        let errorMessage = null;

        if (this.state.error) {
            errorMessage = (
                <p style={{ color: '#f50057' }}>{this.state.error}</p>
            )
        }

        let view = null;
        if (this.state.isSent) {
            view = <Card className={classes.Form}>
                <CardHeader title={messages.PASSWORD_SET} className={classes.Head} />
                <VpnKeyIcon fontSize="large" style={{ fontSize: '70px', marginTop: '35px' }} />
                <p>{messages.PASSWORD_SET_MSG}</p>
                <Button color="primary" component={Link} to={'/signin'} type="button" style={{ marginBottom: '35px' }}>
                    {messages.SIGNIN}
                </Button>
            </Card>
        } else {
            view = (
                <Card className={classes.Form}>
                    <CardHeader title={messages.RESET_PASSWORD} className={classes.Head} />
                    <form onSubmit={this.submitHandler}>
                        <p>{messages.RESET_PASSWORD_SET_PASSWORDS}</p>
                        {errorMessage}
                        {form}
                        <Button color="primary" variant="outlined" type="submit" style={{ marginBottom: '35px' }}>
                            {messages.SET_PASSWORD}
                        </Button>
                    </form>
                </Card>
            );
        }

        if (this.state.loading) {
            view = <Spinner />
        }

        if (this.state.invalidCode) {
            view = (
                <Card className={classes.Form}>
                    <CardHeader title={messages.INVALID_RESET_PASSWORD_CODE} className={classes.Head} />
                    <VpnKeyIcon fontSize="large" style={{ fontSize: '70px', marginTop: '35px' }} />
                    <p>{messages.INVALID_RESET_PASSWORD_CODE_MSG}</p>
                    <Button color="primary" component={Link} to="/reset-password" type="button" style={{ marginBottom: '35px' }}>
                        {messages.RESET_PASSWORD}
                    </Button>
                </Card>
            );
        }

        return (
            <Aux>
                {view}
            </Aux>
        )
    }
}

export default ResetPassword; 